import { hideSidebar, Sidebar } from '@components/sidebar';
import { useScopedTranslate } from '@locale/translate';

import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { ACTION_TYPES } from 'ui/actions/action-config';
import {
  ActionHeader,
  ActionSidebarLoading,
  SidebarProps,
} from 'ui/journey-builder/node-types/common';

import { ConditionFormContent } from './helpers';

const ACTION_TYPE = ACTION_TYPES.condition_v2;

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const { t } = useScopedTranslate(sidebarLocale);

  const editMutation = useUpdateJourneyAction(journeyActionId);

  const { data, isLoading } = useJourneyAction<typeof ACTION_TYPE>(journeyActionId);

  if (isLoading || !data) {
    return <ActionSidebarLoading actionType={ACTION_TYPE} {...props} />;
  }
  return (
    <Sidebar>
      <ActionHeader actionType={ACTION_TYPE} {...props} />
      <Sidebar.Content>
        <ConditionFormContent
          action={data}
          showDescriptionField
          conditionDescription={t('conditionDescription')}
          journeyId={data.journey}
          onCancel={hideSidebar}
          onSubmit={(data) =>
            editMutation.mutateAsync({
              isAutomatic: true,
              action: ACTION_TYPE,
              values: data,
              description: data.description,
            })
          }
        />
      </Sidebar.Content>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    conditionDescription: 'Continues',
  },
};
